var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useReducer } from "react";
/**
 * @deprecated from version 2.0
 */
var useInput = function () {
    var _a = useReducer(function (state, newState) { return (__assign(__assign({}, state), newState)); }, {}), form = _a[0], setFormData = _a[1];
    var handleOnChange = useCallback(function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        setFormData((_a = {}, _a[name] = value, _a));
    }, []);
    var handleOnChangeForValue = useCallback(function (key, value) {
        var _a;
        setFormData((_a = {}, _a[key] = value, _a));
    }, []);
    //Clear all fields at once
    var clearAllFields = function () {
        var _a;
        var _form = {};
        for (var key in form)
            _form = __assign(__assign({}, _form), (_a = {}, _a[key] = '', _a));
        setFormData(_form);
    };
    //Clear one by one field
    var clearList = function () {
        var _a;
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        var _form = {};
        for (var _b = 0, rest_1 = rest; _b < rest_1.length; _b++) {
            var key = rest_1[_b];
            _form = __assign(__assign({}, _form), (_a = {}, _a[key] = '', _a));
        }
        setFormData(__assign(__assign({}, form), _form));
    };
    return { form: form, handleOnChange: handleOnChange, handleOnChangeForValue: handleOnChangeForValue, clearAllFields: clearAllFields, setFormData: setFormData, clearList: clearList };
};
export default useInput;
